<template>
  <div class="page" v-wechat-title="$route.meta.title">
    <!--<div class="img-move">-->
      <!--<img src="../../assets/extend_01.jpg" alt="">-->
    <!--</div>-->


    <!--切换栏-->
    <div class="top-tab" :class="showTopTab==true ? 'curr' : ''" v-if="showTopTab==true">
      <div class="fl border-box" :class="tabCurr==0 ? 'curr':''" @click="tabCurr=0">
        <span>全部</span>
      </div>
      <router-link class="fl border-box" :class="tabCurr==1 ? 'curr':''" @click="tabCurr=1" :to="{path:'/city-history-list',query:{code:code,condition:'renwen',TimeStamp:TimeStamp,appKey:appKeyA}}">
        <span>讲·人文</span>
      </router-link>
      <router-link class="fl border-box" :class="tabCurr==2 ? 'curr':''" @click="tabCurr=2" :to="{path:'/city-history-list',query:{code:code,condition:'qushi',TimeStamp:TimeStamp,appKey:appKeyA}}">
        <span>听·趣史</span>
      </router-link>
      <router-link class="fl border-box" :class="tabCurr==3 ? 'curr':''" @click="tabCurr=3" :to="{path:'/city-food-list',query:{code:code,TimeStamp:TimeStamp,appKey:appKeyA}}">
        <span>说·美食</span>
      </router-link>
      <router-link class="fl border-box" :class="tabCurr==4 ? 'curr':''" @click="tabCurr=4" :to="{path:'/city-view-list',query:{code:code,type:2,sortby:'listens',TimeStamp:TimeStamp,appKey:appKeyA}}">
        <span>游·景区</span>
      </router-link>
    </div>
    <!--轮播图-->
    <div class="banner p027 border-box">
      <Swiper v-if="banners!=null && banners.length >= 1" :banners="banners" :type="'home'"></Swiper>
    </div>

   <!--分类栏-->
    <div class="tab p027 border-box" id="tab">
      <router-link class="tab-li" :to="{path:'/city-history-list',query:{code:code,condition:'renwen',TimeStamp:TimeStamp,appKey:appKeyA}}">讲·人文</router-link>
      <router-link class="tab-li" :to="{path:'/city-history-list',query:{code:code,condition:'qushi',TimeStamp:TimeStamp,appKey:appKeyA}}">听·趣史</router-link>
      <router-link class="tab-li" :to="{path:'/city-food-list',query:{code:code,TimeStamp:TimeStamp,appKey:appKeyA}}">说·美食</router-link>
      <router-link class="tab-li" :to="{path:'/city-view-list',query:{code:code,type:2,sortby:'listens',TimeStamp:TimeStamp,appKey:appKeyA}}">游·景区</router-link>
    </div>

    <!--城市名片视频-->
    <div class="conference-list mt50 p027 new csmp border-box" v-if="videoRes.root != null && videoRes.root.length>0">
      <div class="conference-item-parent">
        <div class='conference-item border-box' @click="goVideoPlay1(videoRes.root[0].id)">
          <div class="conference-item-img loadBg">
            <img class="city_icon_play" src="../../assets/city_icon_play01.png" alt="">
            <img class="img" v-lazy="videoRes.root[0].tvideourl" alt="">
          </div>
          <img class="conference-item-tab" src="../../assets/icon_csmp.png" alt="">
          <div class="conference-item-info clearfix">
            <div class="label-box">
              <div class="conference-item-title hide" style="max-width: 100%;">{{videoRes.root[0].name}}</div>
            </div>
            <div class="clearfix desc" v-if="videoRes.root[0].info!=null">
              <img src="../../assets/icon_03.png" alt="">
              <p class="hide2">{{videoRes.root[0].info}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="conference-bot-parent" v-if="videoRes.root != null && videoRes.root.length>2">
        <div class="conference-bot-item" v-if="videoRes.root != null && videoRes.root.length>1" @click="goVideoPlay1(videoRes.root[1].id)">
          <img class="city_icon_play" src="../../assets/city_icon_play01.png" alt="">
          <img class="img" v-lazy="videoRes.root[1].tvideourl" alt="">
        </div>
        <div class="conference-bot-item" v-if="videoRes.root != null && videoRes.root.length>2" @click="goVideoPlay1(videoRes.root[2].id)">
          <img class="city_icon_play" src="../../assets/city_icon_play01.png" alt="">
          <img class="img" v-lazy="videoRes.root[2].tvideourl" alt="">
        </div>
        <router-link class="conference-bot-item" v-if="videoRes.total>3" :to="{path:'/video-vrlist',query: {code:code,citySite:1,TimeStamp: TimeStamp, appKey: appKeyA}}">查看更多</router-link>
      </div>
    </div>

    <!--分隔行-->
    <div class="split-line" style="margin-top: .47rem;" v-if="vrRes.root!=null && vrRes.root.length>0"></div>

    <!--VR虚拟全景视频-->
    <div v-if="vrRes.root!=null && vrRes.root.length>0">
      <div class="csmp-tit">
        <img class="csmp-tit-icon" src="../../assets/city-tx.png" alt="">
        VR虚拟全景
        <router-link class="list-more" v-if="vrRes.total>1" :to="{path:'/video-vrlist',query: {code:code,citySite:2,TimeStamp: TimeStamp, appKey: appKeyA}}">更多>></router-link>
      </div>
      <router-link v-if="vrRes.root" class="conference-list p027 vr border-box" :to="{path:'/video-vr',query: {id:vrRes.root[0].id,TimeStamp: TimeStamp, appKey: appKeyA}}">
        <img class="icon" src="../../assets/icon_360.png" alt="">
        <div class="img" id="vr-img" v-if="vrRes.root[0].vrimg&&vrRes.root[0].vrimg!=''&&vrRes.root[0].vrimg!=null"></div>
        <img class="img" v-lazy="vrRes.root[0].tvideourl" alt="" v-else>
      </router-link>
      <div class="conference-vrname p027 clearfix">
        <span class="fl hide">{{vrRes.root[0].name}}</span>
        <span class="fr">{{vrRes.root[0].spots}}个景点</span>
    </div>
    </div>

    <!--分隔行-->
    <div class="split-line" style="margin-top: .47rem;"  v-if="signRes.data!=null&&signRes.data.length>0"></div>

    <!--打卡景区-->
    <div v-if="signRes.data!=null&&signRes.data.length>0">
      <div class="csmp-tit">
        <img class="csmp-tit-icon" src="../../assets/city-tx.png" alt="">
        打卡景区
        <router-link class="list-more" v-if="signRes.total>3" :to="{path:'/city-view-list',query:{code:code,sortby:'listens',TimeStamp:TimeStamp,appKey:appKeyA}}">更多>></router-link>
      </div>
      <div class="conference-list p027 near border-box">
        <swiper :options="swiperSign" ref="swiperSign">
          <div class="swiper-slide"  v-for="(item,index) in signRes.data" :key="index">
            <router-link class="conference-near-parent" :to="{path:'/view-detail',query:{shopid:item.id,code:code,TimeStamp:TimeStamp,appKey:appKeyA}}">
              <div class="conference-near-item">
                <img class="img" v-lazy="item.logo" alt="">
                <span class="hide">{{item.name}}</span>
              </div>
            </router-link>
          </div>
        </swiper>
      </div>
    </div>

    <!--分隔行-->
    <div class="split-line" style="margin-top: .47rem;" v-if="renwenList!=null && renwenList.length>0"></div>

    <!--人文趣史-->
    <div v-if="renwenList!=null && renwenList.length>0">
      <div class="csmp-tit" style="padding-bottom: 0;">
        <img class="csmp-tit-icon" src="../../assets/city-tx.png" alt="">
        人文趣史
        <router-link class="list-more" :to="{path:'/city-history-list',query:{code:code,condition:'all',TimeStamp:TimeStamp,appKey:appKeyA}}" v-if="renwenTotal>3">更多>></router-link>
      </div>
      <div class="conference-list history">
        <div class="conference-history-parent border-box" v-for="(item,index) in renwenList">
          <div class="conference-history-item border-box" @click="goVideoPlay(item.id)">
            <div class="fl conference-history-img">
              <img class="img-bg" src="../../assets/city_bg.png" alt="">
            <span class="img-box">
              <img v-lazy="item.tvideourl" alt="">
            </span>
            </div>
            <div class="fr conference-history-info">
              <div class="conference-history-tit hide">{{item.bagname}}</div>
              <div class="conference-history-label">
                <span v-if="item.guidename">{{item.guidename}}</span>
                <span v-if="item.guidetag">{{item.guidetag}}</span>
              </div>
              <div class="conference-history-txt hide2" v-if="item.info">{{item.info}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--分隔行-->
    <div class="split-line" style="margin-top: .47rem;"  v-if="museumList!=null && museumList.length>0"></div>

    <!--博物馆-->
    <div  v-if="museumList!=null && museumList.length>0">
      <div class="csmp-tit">
        <img class="csmp-tit-icon" src="../../assets/city-tx.png" alt="">
        博物馆
        <router-link class="list-more" :to="{path:'/city-museum-list',query:{code:code,TimeStamp:TimeStamp,appKey:appKeyA}}" v-if="museumTotal>5">更多>></router-link>
      </div>
      <div class="swiper-museum border-box">
        <swiper :options="swiperMusume" ref="swiperMusume">
          <div class="swiper-slide"  v-for="(item,index) in museumList" :key="index">
            <div class="slide-img-box">
              <p class="museum-name hide">{{item.name}}</p>
              <img class="img" v-lazy="item.logo">
              <div class="museum-img">
                <img class="img" v-lazy="ite.logo" alt=""  v-for="(ite,index) in item.spots">
              </div>
              <router-link class="sel-more" :to="{path:'/view-detail',query:{shopid:item.id,code:code,TimeStamp:TimeStamp,appKey:appKeyA}}">
                了解更多
                <img src="../../assets/city_icon06.png" alt="">
              </router-link>
            </div>
          </div>
        </swiper>
      </div>
    </div>

    <!--分隔行-->
    <div class="split-line" style="margin-top: .47rem;" v-if="gltjRes.data!=null && gltjRes.data.length>0"></div>

    <!--攻略推荐-->
    <div v-if="gltjRes.data!=null && gltjRes.data.length>0">
      <div class="csmp-tit">
        <img class="csmp-tit-icon" src="../../assets/city-tx.png" alt="">
        攻略推荐
        <router-link class="list-more" :to="{path:'/city-strategy-list',query:{code:code,TimeStamp:TimeStamp,appKey:appKeyA}}" v-if="gltjRes.total>5">更多>></router-link>
      </div>
      <div class="conference-list p027 strategy border-box">
        <div class="conference-strategy-parent">
          <swiper :options="swiperStrategy" ref="swiperStrategy">
            <div class="swiper-slide"  v-for="(item,index) in gltjRes.data" :key="index"  :class="swiperStrategyClass">
              <div class="conference-strategy-item border-box" @click="toStation(item.type,item.id)">
                <img class="img" v-lazy="item.headimg" alt="">
                <img class="mask" src="../../assets/city_icon12.png" alt="">
                <div class="strategy-tit">{{item.label}}</div>
                <div class="strategy-txt hide2">{{item.name}}</div>
              </div>
            </div>
          </swiper>

        </div>
      </div>
    </div>

    <!--分隔行-->
    <div class="split-line" style="margin-top: .47rem;" v-if="foodRes.root!=null && foodRes.root.length>0"></div>

    <!--说美食-->
    <div v-if="foodRes.root!=null && foodRes.root.length>0">
      <div class="csmp-tit" style="padding-bottom: .15rem;">
        <img class="csmp-tit-icon" src="../../assets/city-tx.png" alt="">
        说美食
        <router-link class="list-more" :to="{path:'/city-food-list',query:{code:code,TimeStamp:TimeStamp,appKey:appKeyA}}" v-if="foodRes.total>2">更多>></router-link>
      </div>
      <div class="conference-list p027 food clearfix">
        <div  class="conference-item-parent" v-for="(item,index) in foodRes.root">
          <div class='conference-item border-box' @click="toCityArticle(item.bagtype,item.id)">
            <div class="conference-item-tit hide">{{item.name}}</div>
            <div class="conference-item-img loadBg">
              <span class="label">{{item.bagtype==3?'推文':'语音'}}</span>
             <span class="label-icon"  v-if="item.bagtype==0">
              <img src="../../assets/city_icon05.png" alt="">
            </span>
              <img class="img" v-lazy="item.tvideourl" alt="">
            </div>
            <div class="conference-item-bot border-box box">
              <div class="flex">
                <img class="icon" style="top:-.04rem;" src="../../assets/city_icon13.png" alt="">{{item.zan}}
              </div>
              <div class="flex">
                <img class="icon" src="../../assets/city_icon02.png" alt="">{{item.comment}}
              </div>
              <!--<div class="flex">-->
                <!--<img class="icon" src="../../assets/city_icon03.png" alt="">121-->
              <!--</div>-->
              <div class="flex">
                <img class="icon" src="../../assets/city_icon04.png" alt="">{{item.share}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--分隔行-->
    <div class="split-line" style="margin-top: .47rem;" v-if="total>0"></div>

    <!--游景区-->
    <div v-if="total>0">
      <div class="csmp-tit" style="padding-bottom: .25rem;">
        <img class="csmp-tit-icon" src="../../assets/city-tx.png" alt="">
        游景区
        <!--<router-link class="list-more" :to="{path:'/city-view-list',query:{code:code,type:2,sortby:'listens',TimeStamp:TimeStamp,appKey:appKeyA}}" v-if="nearTotal>6">更多>></router-link>-->
      </div>
      <div class="conference-list p027 half clearfix">
        <div  class="conference-item-parent" @click="toViewDetail(item.id)" v-for="(item,index) in root">
          <div class='conference-item border-box'>
            <div class="conference-item-img loadBg">
              <img class="img" v-lazy="item.logo" alt="">
            </div>
            <div class="conference-item-info clearfix">
              <div class="label-box">
                <div class="conference-item-title hide" style="max-width: 100%;">{{item.name}}</div>
              </div>
              <div class="right-info">
                <div class='conference-item-info-label'>
                  <img src="../../assets/station-icon-view.png" alt="">
                  <span class="icon-time">{{item.spots}}个讲解点</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <p class="load-tip">{{loadText}}</p>

    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>
  </div>
</template>
<script>
  import PhotoSphereViewer from 'photo-sphere-viewer'
  import 'photo-sphere-viewer/dist/photo-sphere-viewer.css'
  import 'swiper/dist/css/swiper.css'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import Swiper from '../../components/Swiper'
  import {uploadUserBrowse,citySiteIndex,citySiteView} from "@/service/getData";
  import {wxGetPosition,wxShareme, getCityInfo} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import P400 from '../../components/P400'
  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return {
        userInfo: {}, //用户信息
        latlng: {lat: '', lng: ''}, //经纬度信息
        cityInfo: { citycode: "1", city: "全国", address: "" },
        TimeStamp: new Date().getTime(),  //获取当前时间
        appKey: '',
        appKeyA: '',
        code: this.$route.query.code || "510100",
        loadEnd: false, //数据加载结束则赋值为true
        banners: [],
        videoRes:'',//城市名片
        vrRes:'',//VR视频
        signRes:'',//附近推荐打卡景区
        renwenList: [], //讲人文
        renwenTotal: 0, //人文总数
        museumList:[],//博物馆
        museumTotal: 0,//博物馆总数
        gltjRes:'',//攻略推荐
        foodRes:'',//说美食
        near: [],//附近景区
        nearTotal: [],//附近景区总数

        root:[],//景区列表
        total: '',//景区总数
        type:  '2',
        sortby:  'listens', //distance距离  listens人气、综合
        sorttype: 'desc', //desc降序 asc升序
        page: 1,
        rows: 8,
        loadText: "数据加载中",
        swiperSign: {
          slidesPerView: 'auto',
          freeMode: true,
          speed: 500,//切换速度
          watchOverflow: true, //当没有足够的slide切换时，例如只有1个slide（非loop），swiper会失效且隐藏导航等。默认不开启这个功能。
          loop: false,//开启循环模式
          autoplay:false,
          observeParents:true,
          observer: true,
          preventClicksPropagation: false,//阻止click冒泡。拖动Swiper时阻止click事件。
          simulateTouch: false,//鼠标模拟手机触摸。默认为true，Swiper接受鼠标点击、拖动。
          pagination: false,
        },
        swiperStrategyClass:'',//攻略推荐样式
        swiperStrategy: {
          slidesPerView: 'auto',
          freeMode: true,
          speed: 500,//切换速度
          watchOverflow: true, //当没有足够的slide切换时，例如只有1个slide（非loop），swiper会失效且隐藏导航等。默认不开启这个功能。
          loop: false,//开启循环模式
          autoplay:false,
          observeParents:true,
          observer: true,
          preventClicksPropagation: false,//阻止click冒泡。拖动Swiper时阻止click事件。
          simulateTouch: false,//鼠标模拟手机触摸。默认为true，Swiper接受鼠标点击、拖动。
          pagination: false,
        },
        swiperMusume: {
          initialSlide: 0,
          height: 335,
          speed: 500,//切换速度
          centeredSlides : true,
          watchOverflow: true, //当没有足够的slide切换时，例如只有1个slide（非loop），swiper会失效且隐藏导航等。默认不开启这个功能。
          loop: false,//开启循环模式
          autoplay:{
            delay: 4000,
            disableOnInteraction: false
          },
          slidesPerView: 'auto',
          spaceBetween: 0,
          observeParents:true,
          observer: true,
          preventClicksPropagation: false,//阻止click冒泡。拖动Swiper时阻止click事件。
          simulateTouch: false,//鼠标模拟手机触摸。默认为true，Swiper接受鼠标点击、拖动。
          pagination: false,
        },
        showTopTab:false,//是否显示顶部切换栏
        tabCurr:0,//顶部切换栏
        P400: 0, //系统维护中
        PSV: null, //全景图片
      }
    },
    computed: {},

    created(){
      let self = this;
      this.$loading.show('数据加载中');
      this.userInfo = getStore("userInfo");

      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey;
      if (this.appKey) {
        this.appKey = encodeURIComponent(this.appKey);
        setStore("appKey", {"appKey": this.appKey});
        this.sendUserBrowse();
      } else {
        setStore("appKey", {"appKey": ""});
      }

      let cityInfo = getStore("cityInfo");
      if (cityInfo == null || cityInfo.citycode == null || cityInfo.citycode == "") {
        getCityInfo(function (res) {
          self.latlng = res;
          self.cityInfo = { citycode: "1", city: "全国", address: "" };
          setStore("cityInfo",self.cityInfo);
          self.initData();
          self.getViewList(self.page);
        });
      } else {
        this.cityInfo = getStore("cityInfo");
        wxGetPosition(function (res) {
          self.latlng = {lat: res.latitude, lng: res.longitude};
          self.initData();
          self.getViewList(self.page);
        });
      }

      window.addEventListener("scroll",this.handleScroll)
      window.addEventListener("scroll",this.handleFun);
    },
    beforeDestroy(){
      window.removeEventListener("scroll",this.handleScroll)
      window.removeEventListener("scroll",this.handleFun)
      if (this.PSV) {
        this.PSV.destroy()
      }
    },
    destroyed(){
      window.removeEventListener("scroll",this.handleScroll,false)
      window.removeEventListener("scroll",this.handleFun)
    },
    methods: {
      //初始化：获取景区数据
      async initData(){
        this.loadEnd = false;

        //获取景区数据
        let resCity = await citySiteIndex({
          TimeStamp: this.TimeStamp,
          lat: this.latlng.lat || '',
          lng: this.latlng.lng || '',
          code: this.code || ''
        });
        if (resCity.errcode == "00000") {
          this.$loading.hide();
          this.loadEnd = true;
          this.banners = resCity.data.banner;
          this.videoRes = resCity.data.video;
          this.vrRes = resCity.data.vr;
          this.signRes = resCity.data.sign;
          this.renwenList = resCity.data.renwen.root;
          this.renwenTotal = resCity.data.renwen.total;
          this.museumList = resCity.data.museum.data;
          this.museumTotal = resCity.data.museum.total;
          this.gltjRes = resCity.data.root;
          this.foodRes = resCity.data.food;
//          this.near = resCity.data.near.root;
//          this.nearTotal = resCity.data.near.total;


          //判断攻略推荐样式类型
          if(this.gltjRes.total==1){
            this.swiperStrategyClass = 'one';
          }else if(this.gltjRes.total==2){
            this.swiperStrategyClass = 'two';
          }else{
            this.swiperStrategyClass = 'more';
          }
          if(resCity.data.title == null){
            this.$route.meta.title = '城市名片';
          }else{
            this.$route.meta.title = resCity.data.title;
          }

          var share = resCity.data.share;
          let link = '/city-site?code=' + this.code + '&TimeStamp=' + this.TimeStamp + '&appKey=' + this.appKey;
          if(share == null){
            let title = (resCity.data.title || '') + '城市名片';
            let desc = '讲人文 . 听趣史 . 说美食 . 游景区';
            let img = this.banners[0].imgurl;
            wxShareme(title, desc, img, link);
          }else {
            wxShareme(share.title,share.desc,share.logo,link);
          }
        } else {
          this.$toast(resCity.errmsg);
          this.P400 = 1;
          this.$route.meta.title = '请稍后访问...';
        }
      },

      async getViewList(page){

        let res = await citySiteView({
          TimeStamp: this.TimeStamp,
          code: this.code || '',
          lat: this.latlng.lat || '',
          lng: this.latlng.lng || '',
          page: page,
          rows: this.rows,
          sortby: this.sortby,
          sorttype: this.sorttype,
          openid: this.userInfo.openid,
          type: this.type
        });

        if (res.errcode === '00000'){
          this.$loading.hide();
          this.total = res.data.total
          let root = res.data.data
          if (page >= Math.ceil(this.total / this.rows)) {
            this.loadText = '已经到底了'
          } else {
            this.loadText = '加载更多'
          }
          if (root.length > 0) {
            this.root = [...this.root, ...root];
          } else {
            if (page == 1) {
              this.root = [];
              this.loadText = '暂无数据'
            } else {
              this.loadText = '已经到底了'
            }
          }

        }
      },

      handleFun: function (){
        let self = this;
        self.$nextTick(function() {
          loadMore(self,function(page){
            self.getViewList(page);
          });
        })
      },

      toViewDetail(id){
        this.$router.push({
          path: `/view-detail?${'shopid='+ id+ '&code='+ this.code + '&TimeStamp='+ this.TimeStamp+'&appKey='+this.appKey}`
        });
      },

      //跳转到专辑详情页
      goVideoPlay(id){
        this.$router.push({
          path: `/video-play?${'id='+id+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey}`
        });
      },

      //跳转到视频详情页
      goVideoPlay1(id){
        this.$router.push({
          path: `/video-play1?${'id='+id+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey}`
        });
      },

      //跳转到路线推荐页
      toStation(type,id){
        if(type==0){
          this.$router.push({
            path: `/station?${'specialId='+id+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey}`
          });
        }else{
          this.$router.push({
            path: `/city-strategy-detail?${'id='+id+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey}`
          });
        }

      },

      //跳转到推文页面
      toCityArticle(type,id){
        if(type==3){
          this.$router.push({
            path: `/city-article?${'id='+id+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey}`
          });
        }else{
          this.$router.push({
            path: `/video-play?${'id='+id+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey}`
          });
        }
      },


      handleScroll () {
        let scrollY = window.scrollY;
        if (scrollY > 200) {
          this.showTopTab = true
        } else {
          this.showTopTab = false
        }

//        var tabTop = document.getElementById("tab").getBoundingClientRect().top;
//        if(tabTop<0){
//          this.showTopTab = true
//        }else{
//          this.showTopTab = false
//        }
      },

      //上传浏览数据
      async sendUserBrowse(){
        let res = await uploadUserBrowse({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          appKey: this.appKey,
        });
      },

      showPhotoVR(imgurl,obj){
//            var imgurl = require('../../assets/qj.jpg');
        this.PSV = PhotoSphereViewer({
          container: obj,
          panorama: imgurl,
          autoload: true, //自动播放
          time_anim: 2000, //默认2000
          anim_speed: '2rpm', //默认2rpm
          navbar: false  //不显示下面的导航栏
        });
      },

    },
    watch:  {
      vrRes(){
        var self = this;
        this.$nextTick(function(){
          if(self.vrRes.root[0].vrimg && self.vrRes.root[0].vrimg != '' && self.vrRes.root[0].vrimg != null){
            self.showPhotoVR(self.vrRes.root[0].vrimg,'vr-img');
          }
        })
      },
    },
    components: {
        Swiper,
          swiper,
          swiperSlide,P400
    },
    //格式化数据
    filters: {
      initNumber: function (num) {
        if (num > 10000) {
          num = (num / 10000).toFixed(2) + '万'
        } else if (num > 1000) {
          num = (num / 1000).toFixed(2) + '千'
        }
        return num;
      }
    }


  }

</script>

<style scoped>
  @import "../../style/view.css";
  /**{ touch-action: default }*/
  * { touch-action: pan-y; }
  .page{width:100vw;padding:.4rem 0;background-color:#fff;overflow-x: hidden;}
  .conference-list,.conference-strategy-item{position: relative;}
  .split-line{width: 100vw;height: .16rem;background: #f9f9f9;}
  .csmp-tit{padding:.3rem .27rem;font: bold .34rem "Microsoft YaHei";color: #333;}
  .csmp-tit img{float:left;width: auto;height: .24rem;margin-top: .12rem;margin-right: .08rem;}
  .csmp-tit .list-more{float: right;padding: 0;margin-top: .05rem;font-size: .24rem;color: #666;}
  .conference-item-info-label img{width:.17rem;height:.26rem;}

  /*顶部切换栏*/
  .top-tab{position: fixed;left: 0;top:0;z-index:3;width: 100%;height: .74rem;background: #fff;box-shadow: 0 .02rem .08rem #d0d0d0;opacity: 0;}
  .top-tab.curr{-webkit-animation:topTab .3s linear;animation:topTab .3s linear;-webkit-animation-fill-mode: forwards;animation-fill-mode: forwards; }
  .top-tab .fl{width:20%;margin-top: .12rem;font: .28rem/.5rem "Microsoft YaHei";color: #333;text-align: center;}
  .top-tab .fl span{display: inline-block;height: .5rem;line-height: .5rem;padding: 0 .19rem;}
  .top-tab .fl.curr span{color: #fff;background: #f3a600;border-radius: .3rem;}
  @-webkit-keyframes topTab {from{opacity: 0;}to{opacity: 1;}}
  @keyframes topTab {from{opacity: 0;}to{transform: translateY(0);opacity: 1;}}

  /* banner */
  .banner{position:relative;height:3.72rem;border-radius:.1rem}
  .swiper-pagination-bullet{border-radius: 50%!important;}

  /*分类栏*/
  .tab{width: 100%;height: .76rem;margin-top:.5rem;font: .28rem/.76rem "Microsoft YaHei";color: #fff;text-align: center;}
  .tab-li{float:left;width: 22.4%;height: 100%;margin-right: 3.4666%;border-radius: .1rem;text-shadow:0 0 0.04rem rgba(40,40,40,.2);color: #fff;font-weight: bold;}
  .tab-li:last-child{margin-right: 0;}
  .tab-li:nth-of-type(1){background-image: linear-gradient(120deg,#b5a9fb,#cbc2ff);box-shadow: 0 0 .24rem #f6f4fd;}
  .tab-li:nth-of-type(2){background-image: linear-gradient(120deg,#fd98b0,#ffc1b7);box-shadow: 0 0 .24rem #feeff4;}
  .tab-li:nth-of-type(3){background-image: linear-gradient(120deg,#f4c57b,#ffd494);box-shadow: 0 0 .24rem #fdf4e8;}
  .tab-li:nth-of-type(4){background-image: linear-gradient(120deg,#7bc0f4,#95dbff);box-shadow: 0 0 .24rem #eef8fd;}

  /*城市名片*/
  .new .conference-item-parent .conference-item-title{ font-size: .32rem; color: #010101; }
  .new .conference-item-parent .conference-item-img{border-radius: .1rem; }
  .new .conference-item-parent .conference-item-tab{ position: absolute;left: .22rem;top: .2rem;z-index: 1;width: 1.13rem;height: .36rem; }
  .new .conference-item-parent .conference-item-info{height: auto;padding-bottom: .2rem;padding-left: .17rem; border-radius: 0 0 .08rem .08rem;box-shadow: 0 .06rem .1rem rgba(102,102,102,.1); }
  .new .conference-item-parent .desc{ position: relative; clear: both; padding-top: .08rem; }
  .new .conference-item-parent .desc img{ position: absolute;left: 0;top: 0;z-index: 2;width: .23rem;height: .22rem; }
  .new .conference-item-parent .desc p{ font-size: .2rem; line-height: .28rem; color: #666; text-indent: .42rem;}
  .csmp .conference-item-img{height: 3.34rem;}
  .csmp .city_icon_play{position: absolute;top:50%;left: 50%;width: 1.02rem!important;height: 1.02rem!important;-webkit-transform: translate(-50%,-50%);transform: translate(-50%,-50%);}
  .csmp .label-box{width:100%;height: .68rem;}
  .csmp .conference-item-title{height: .68rem;font: bold .32rem/.74rem "Microsoft YaHei";}
  .csmp .conference-bot-parent{height:1.3rem;margin-top: .25rem;}
  .csmp .conference-bot-parent .conference-bot-item{float:left;position:relative;width: 32.6%;height: 100%;margin-right: 1.1%;border-radius: .1rem;overflow: hidden;}
  .csmp .conference-bot-parent .conference-bot-item:last-child{margin-right: 0;font: .26rem/1.3rem "Microsoft YaHei";color: #fff;text-align: center;background-image: linear-gradient(to top right,#6c6dba,#4f85f8,#2b80ef);}
  .csmp .conference-bot-parent .city_icon_play{width: .69rem!important;height: .69rem!important;}

  /*VR全景视频*/
  .conference-list.vr{display: block;width:100%;height: 3.02rem;border-radius: .1rem;overflow: hidden;}
  .conference-list.vr .img{position:relative;z-index:1;border-radius: .1rem;overflow: hidden;}
  .conference-list.vr .icon{position: absolute;z-index: 2;top:50%;left: 50%;width: auto;height:.61rem;-webkit-transform: translate(-50%,-50%);transform: translate(-50%,-50%);}
  .conference-vrname{ padding-top: .2rem; line-height: .34rem; color: #010101; }
  .conference-vrname .fl{ font-size: .3rem; max-width: 80%; }
  .conference-vrname .fr{ font-size: .22rem; }

  /*打卡景区*/
  .conference-list.near{width:100%;height: 1.6rem;overflow:hidden;}
  .conference-list.near .swiper-slide{position:relative;display: inline-block;width: 2.7rem;height: 100%;margin-right:.24rem;border-radius: .1rem;}
  .conference-list.near .swiper-slide:last-child{margin-right: 0;}
  .conference-near-item{position:relative;width:100%;height: 100%;overflow: hidden;}
  .conference-near-item .img{border-radius: .1rem;}
  .conference-near-item span{position: absolute;left:0;bottom:.21rem;height:.36rem; max-width: 85%;padding-left: .1rem;padding-right: .15rem;background: #eb9500;border-radius: 0 .3rem .3rem 0;font: .2rem/.36rem "Microsoft YaHei";color: #fff;letter-spacing: .01rem;}

  /*讲人文通趣史*/
  .conference-history-item{ width: 100%;height: 2.1rem;padding:.12rem .27rem;margin-top:.2rem;box-shadow: 0 .06rem .1rem rgba(102,102,102,.1); }
  .conference-history-img{ position: relative;width:2.34rem;height: 100%;margin-right: .2rem;}
  .conference-history-img .img-bg{ position: absolute;left: 0;top: 0;width: 2.34rem;height: 100%;}
  .conference-history-img .img-box{ position: absolute;top:.3rem;right:.36rem;width: 1.26rem;height: 1.26rem;border-radius: 50%;overflow: hidden;}
  .conference-history-img .img-box img{ width: 100%;height: 100%;border-radius: 50%;object-fit: cover;}
  .conference-history-info{ width: calc(100% - 2.54rem);height: 100%;}
  .conference-history-tit{ margin-top:.08rem;font-size: .3rem;color: #303030;}
  .conference-history-label{ margin-top:.2rem;font-size: .21rem;color: #303030;}
  .conference-history-label span{ display: inline-block;padding: 0 .11rem 0 .06rem;border-right: 1px solid #c0c0c0;}
  .conference-history-label span:first-child{ padding-left: 0;}
  .conference-history-label span:last-child{ border-right: none;}
  .conference-history-txt{ margin-top:.18rem;font: .22rem/.32rem "Microsoft YaHei";color: #555;}

  /*博物馆*/
  .swiper-museum{width: 100%;height: 3.75rem;margin-top:-.2rem;overflow-x: hidden;}
  .swiper-museum .swiper-container{overflow: initial;}
  .swiper-museum .swiper-slide{width: 80%!important;height: 3.35rem!important;margin-top:.2rem;border-radius: .16rem;}
  .swiper-museum .swiper-slide .slide-img-box{position:relative;width: 100%;height: 100%;border-radius: .16rem;box-shadow:0 0 .18rem rgba(0,0,0,.2);}
  .swiper-museum .swiper-slide .slide-img-box img{width:100%;height:1.5rem;border-radius: .16rem .16rem 0 0;}
  .swiper-museum .swiper-slide.swiper-slide-prev .slide-img-box,.swiper-museum .swiper-slide.swiper-slide-next .slide-img-box{-webkit-transition:all ease .3s;transition:all ease .3s;-webkit-transform: scale(.9);transform: scale(.9);}
  .swiper-museum .swiper-slide.swiper-slide-prev .slide-img-box:after,.swiper-museum .swiper-slide.swiper-slide-next .slide-img-box:after,.swiper-museum .swiper-slide.swiper-slide-prev .sel-more:after,.swiper-museum .swiper-slide.swiper-slide-next .sel-more:after{content:'';position: absolute;top:0;left: 0;width: 100%;height: 100%;border-radius: .16rem;background: rgba(0,0,0,.6);}
  .swiper-museum .swiper-slide .museum-name{position: absolute;top:.46rem;left:.16rem;right:.16rem;font: bold .48rem "Microsoft YaHei";color: #fff;}
  .swiper-museum .swiper-slide .sel-more{position: absolute;bottom: .34rem;right: -.16rem;z-index:2;height: .5rem;padding-left:.22rem;padding-right:.12rem;font: .24rem/.5rem "Microsoft YaHei";color: #fff;border-radius: .3rem;background-image: linear-gradient(to right,#fccd5b,#faaf39);  box-shadow: 0 -0.04rem 0.04rem #feecc2;  }
  .swiper-museum .swiper-slide.swiper-slide-prev .sel-more:after,.swiper-museum .swiper-slide.swiper-slide-next .sel-more:after{content:'';position: absolute;top:0;left: 0;width: 100%;height: 100%;border-radius: .3rem;background: rgba(0,0,0,.76);}
  .swiper-museum .swiper-slide.swiper-slide-prev .sel-more,.swiper-museum .swiper-slide.swiper-slide-next .sel-more{box-shadow: none;}
  .swiper-museum .swiper-slide .sel-more img{float: right;width: .26rem;height: .26rem;margin-left: .12rem;margin-top: .12rem;border-radius: 50%;}
  .swiper-museum .swiper-slide .museum-img{width:100%;height:1.12rem;margin-top: .24rem;}
  .swiper-museum .swiper-slide .museum-img img{float:left;width:1.12rem;height:100%;margin-left: .22rem;border-radius: .07rem;object-fit: cover;}

  /*攻略推荐*/
  .conference-strategy-parent{width:100%;height:3.4rem;}
  .conference-strategy-parent .swiper-container, .conference-strategy-parent .swiper-wrapper{height: 100%;}
  .conference-strategy-parent .swiper-slide{width: 80%; margin-right: .24rem;}
  .conference-strategy-parent .swiper-slide:last-child{margin-right: 0;}
  .conference-strategy-parent .swiper-slide.one{width: 100%!important;}
  .conference-strategy-parent .swiper-slide.two{width: 48.5%!important;}
  .conference-strategy-parent .swiper-slide.two:first-child{margin-right: 3%!important;}
  .conference-strategy-item{float: left;position:relative;width:100%;height:100%;padding: .16rem .2rem;border-radius: .1rem;color: #fff;}
  .conference-strategy-item .img{position: absolute;top:0;left: 0;width: 100%;height: 100%;border-radius: .1rem;}
  .conference-strategy-item .mask{position: absolute;top:0;left: 0;width: 100%;height: 100%;border-radius: .1rem;object-fit: cover;background: none;}
  .strategy-tit{ position:relative;z-index:1;font: bold .34rem "Microsoft YaHei";font-style: italic;}
  .strategy-txt{ position:relative;z-index:1;margin-top:.24rem;font:.24rem/.34rem "Microsoft YaHei";}

  /*说美食*/
  .conference-list.food .conference-item{padding:.26rem .3rem 0;margin-top:.28rem;box-shadow: 0 0.02rem 0.24rem rgba(0,0,0,.1); }
  .conference-list.food .conference-item-img{margin-top: .18rem;border-radius: .1rem;overflow: hidden;}
  .conference-list.food .conference-item-tit{font: bold .28rem "Microsoft YaHei";color: #0b0b0b;}
  .conference-list.food .label{position: absolute;top:.3rem;left:0;height:.36rem;padding-left: .15rem;padding-right: .2rem;font: .2rem/.36rem "Microsoft YaHei";background: #f7610b;color: #fff;border-radius: 0 .3rem .3rem 0;letter-spacing: .01rem;}
  .conference-list.food .label-icon{position: absolute;top:50%;left: 50%;padding: .14rem .2rem .17rem;border-radius: .08rem;background: rgba(0,0,0,.6);-webkit-transform: translate(-50%,-50%);transform: translate(-50%,-50%);}
  .conference-list.food .label-icon img{float:left;width: .56rem;height: auto;}
  .conference-list.food .conference-item-bot{ height: .86rem;padding-top: .28rem;padding-bottom: .3rem;font: .22rem/.28rem "Microsoft YaHei";color: #999;text-align: center;}
  .conference-list.food .conference-item-bot .icon{position: relative;display:inline-block;width: auto;height: .28rem;margin-right: .1rem;vertical-align: middle;}
  .conference-list.food .conference-item-bot .flex{border-right: 1px solid #ccc;}
  .conference-list.food .conference-item-bot .flex:last-child{border-right: none;}

  /*附近景区*/
  .half .conference-item-parent{float: left;width:50%;}
  .half .conference-item-parent:nth-of-type(odd) .conference-item{padding-right:3%;}
  .half .conference-item-parent:nth-of-type(even) .conference-item{padding-left:3%;}
  .half .conference-item-parent .conference-item-img{height:2.7rem; border-radius: .08rem .08rem 0 0; }
  .half .conference-item-parent .conference-item-info{height:1rem; padding-left: .17rem; border-radius: 0 0 .08rem .08rem;box-shadow: 0 .06rem .1rem rgba(102,102,102,.1); }
  .half .conference-item-parent .conference-item-title{font-size:.26rem;}
  .half .conference-item-parent .label-box{width: 100%;height:.48rem; line-height: .48rem; padding-top: .08rem; }
  .half .conference-item-parent .right-info{width: 100%;text-align: left;}

</style>



// WEBPACK FOOTER //
// src/page/city-site/city-site.vue